import type { Banner, MarketDynamicBanner } from '../model/types';

export const isDynamicMarketBanner = (banner: Banner): banner is MarketDynamicBanner =>
  banner.type === 'DYNAMIC_BANNER' && banner.bannerType === 'MARKET';
